import type {
  AccordionFragment,
  EmbedAccordionGroupFragment,
  EmbedCustomContentFragment,
  RichTextAccordionFragment,
} from '@seek/cmsu-cms-connect';
import { AccordionGroup } from '@seek/cmsu-components';
import { renderers } from '@seek/cmsu-rich-text';
import { Box, ContentBlock } from 'braid-design-system';

import type { ArticleAdditionalData } from 'src/client/pages/Article';

import { CustomContent } from '../../CustomContent/CustomContent';

export const toAccordions = (
  accordions: RichTextAccordionFragment[],
): AccordionFragment[] =>
  accordions.map((accordion) => ({
    id: accordion.id,
    label: accordion.label,
    content: accordion.content,
    locale: accordion.locale,
  }));

export const richTextRenderers = (additionalData?: ArticleAdditionalData) => ({
  ...renderers,
  embed: {
    EmbedAccordionGroup: ({ accordion }: EmbedAccordionGroupFragment) => (
      <Box background="surface" paddingX="gutter" paddingY="gutter">
        <ContentBlock>
          <AccordionGroup accordions={toAccordions(accordion)} />
        </ContentBlock>
      </Box>
    ),
    EmbedCustomContent: ({ title }: EmbedCustomContentFragment) => (
      <CustomContent title={title} additionalData={additionalData} />
    ),
  },
});
